import { render } from "./TurnstileWidget.vue?vue&type=template&id=536a3066"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__